import type { Language } from '@/types/index';

type Translations = {
  [key: string]: {
    en: string;
    ru: string;
    pl: string;
  };
};

export const translations: Translations = {
  // Navigation
  home: { en: 'Home', ru: 'Главная', pl: 'Główna' },
  all: { en: 'All', ru: 'Все', pl: 'Wszystko' },
  articles: { en: 'Articles', ru: 'Статьи', pl: 'Artykuły' },
  allArticles: { en: 'All Articles', ru: 'Все статьи', pl: 'Wszystkie artykuły' },
  places: { en: 'Places', ru: 'Места', pl: 'Miejsca' },
  allPlaces: { en: 'All Places', ru: 'Все места', pl: 'Wszystkie miejsca' },
  events: { en: 'Events', ru: 'События', pl: 'Imprezy' },
  settings: { en: 'Settings', ru: 'Настройки', pl: 'Ustawienia' },

  // Headers
  latestArticles: { en: 'Latest Articles', ru: 'Последние статьи', pl: 'Najnowsze artykuły' },
  promotedPlaces: { en: 'Promoted Places', ru: 'Рекомендуемые места', pl: 'Promowane miejsca' },
  featured: { en: 'Featured', ru: 'Избранное', pl: 'Wyróżnione' },
  promoted: { en: 'Promoted', ru: 'Популярное', pl: 'Promowane' },
  explore: { en: 'Explore', ru: 'Исследуйте', pl: 'Odkrywaj' },

  // Categories
  family: { en: 'Family', ru: 'Семья', pl: 'Rodzina' },
  couples: { en: 'Couples', ru: 'Пары', pl: 'Pary' },
  nature: { en: 'Nature', ru: 'Природа', pl: 'Natura' },
  culture: { en: 'Culture', ru: 'Культура', pl: 'Kultura' },

  living: { en: 'Living', ru: 'Проживание', pl: 'Mieszkanie' },
  services: { en: 'Services', ru: 'Услуги', pl: 'Usługi' },
  legal: { en: 'Legal', ru: 'Юридическое', pl: 'Prawne' },
  lifestyle: { en: 'Lifestyle', ru: 'Образ жизни', pl: 'Styl życia' },

  // Settings
  appSettings: { en: 'App Settings', ru: 'Настройки приложения', pl: 'Ustawienia aplikacji' },
  language: { en: 'Language', ru: 'Язык', pl: 'Język' },
  selectLanguage: { en: 'Select Language', ru: 'Выберите язык', pl: 'Wybierz język' },
  currency: { en: 'Currency', ru: 'Валюта', pl: 'Waluta' },
  selectCurrency: { en: 'Select Currency', ru: 'Выберите валюту', pl: 'Wybierz walutę' },
  widgetsSettings: { en: 'Widgets Settings', ru: 'Настройки виджетов', pl: 'Ustawienia widżetów' },
  manageWidgets: { en: 'Manage Widgets', ru: 'Управление виджетами', pl: 'Zarządzaj widżetami' },

  // Help & Legal
  help: { en: 'Help', ru: 'Справка', pl: 'Pomoc' },
  aboutUmland: { en: 'About Umland', ru: 'Об Umland', pl: 'O Umland' },
  reportIssue: { en: 'Report an Issue', ru: 'Сообщить о проблеме', pl: 'Zgłoś problem' },
  other: { en: 'Other', ru: 'Другое', pl: 'Inne' },
  privacyPolicy: { en: 'Privacy Policy', ru: 'Политика конфиденциальности', pl: 'Polityka prywatności' },
  termsOfService: { en: 'Terms of Service', ru: 'Условия использования', pl: 'Warunki użytkowania' },
  changelog: { en: 'Changelog', ru: 'История изменений', pl: 'Historia zmian' },

  // Details
  usefulOrganizations: { en: 'Useful Organizations', ru: 'Полезные организации', pl: 'Przydatne organizacje' },
  contact: { en: 'Contact', ru: 'Контакт', pl: 'Kontakt' },
  website: { en: 'Website', ru: 'Веб-сайт', pl: 'Strona internetowa' },
  phone: { en: 'Phone', ru: 'Телефон', pl: 'Telefon' },
  address: { en: 'Address', ru: 'Адрес', pl: 'Adres' },
  location: { en: 'Location', ru: 'Местоположение', pl: 'Lokalizacja' },

  // Favorites
  favorites: { en: 'Favorites', ru: 'Избранное', pl: 'Ulubione' },
  noFavorites: { en: 'No favorites yet', ru: 'Пока нет избранного', pl: 'Brak ulubionych' },

  // Related content
  relatedArticles: { en: 'Related Articles', ru: 'Связанные статьи', pl: 'Powiązane artykuły' },
  noRelatedArticles: { en: 'No related articles', ru: 'Нет связанных статей', pl: 'Brak powiązanych artykułów' },

  // Holiday-related
  publicHoliday: { en: 'Public Holiday', ru: 'Государственный праздник', pl: 'Święto państwowe' },
  observance: { en: 'Observance', ru: 'Праздничный день', pl: 'Obserwacja' },
  daysUntil: { en: 'days until', ru: 'дней до', pl: 'dni do' },
  today: { en: 'Calendar', ru: 'Календарь', pl: 'Kalendarz' },

  // Widgets
  currencyRate: { en: 'Currency', ru: 'Валюта', pl: 'Waluta' },
  currencyWidget: { en: 'Currency Widget', ru: 'Виджет валюты', pl: 'Widżet waluty' },
  weather: { en: 'Weather', ru: 'Погода', pl: 'Pogoda' },
  weatherWidget: { en: 'Weather Widget', ru: 'Виджет погоды', pl: 'Widżet pogody' },
  air: { en: 'Air', ru: 'Воздух', pl: 'Powietrze' },
  airWidget: { en: 'Air Widget', ru: 'Виджет воздуха', pl: 'Widżet powietrza' },
  calendar: { en: 'Calendar', ru: 'Календарь', pl: 'Kalendarz' },
  calendarWidget: { en: 'Calendar Widget', ru: 'Виджет календаря', pl: 'Widżet kalendarza' },
  nextHoliday: { en: 'Holidays', ru: 'Праздники', pl: 'Święta' },
  holidayWidget: { en: 'Holiday Widget', ru: 'Виджет праздников', pl: 'Widżet świąt' },
  holidays: { en: 'Holidays', ru: 'Праздники', pl: 'Święta' },
  upcomingHolidays: { en: 'Upcoming Holidays', ru: 'Предстоящие праздники', pl: 'Nadchodzące święta' },

  // Word of the Day
  wordOfDay: { en: 'Word of the Day', ru: 'Слово дня', pl: 'Słowo dnia' },
  wordWidget: { en: 'Word Widget', ru: 'Виджет слова', pl: 'Widżet słowa' },
  translation: { en: 'Translation', ru: 'Перевод', pl: 'Tłumaczenie' },
  examples: { en: 'Examples', ru: 'Примеры', pl: 'Przykłady' },

  // UI
  loading: { en: 'Loading...', ru: 'Загрузка...', pl: 'Ładowanie...' },
  error: { en: 'Error loading data', ru: 'Ошибка загрузки данных', pl: 'Błąd ładowania danych' },
  noResults: { en: 'No results found', ru: 'Результаты не найдены', pl: 'Nie znaleziono wyników' },
  seeAll: { en: 'See All', ru: 'Смотреть все', pl: 'Zobacz wszystko' },

  // Share & Favorites
  share: { en: 'Share', ru: 'Поделиться', pl: 'Udostępnij' },
  linkCopied: { en: 'Link copied!', ru: 'Ссылка скопирована!', pl: 'Link skopiowany!' },
  addedToFavorites: { en: 'Added to favorites', ru: 'Добавлено в избранное', pl: 'Dodano do ulubionych' },
  removedFromFavorites: { en: 'Removed from favorites', ru: 'Удалено из избранного', pl: 'Usunięto z ulubionych' },
};

export const getTranslation = (key: string, language: Language): string => {
  return translations[key]?.[language] || key;
};
